(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-bottom-bar"] && !Shopify.designMode) return;
  try {
    
class MobileBottomBar extends HTMLElement {
  connectedCallback() {
    this.bp = parseInt(this.dataset.bp, 10) || 749;
    this.mq = window.matchMedia(`(max-width: ${this.bp}px)`);

    this.onMq = () => this.applySpacing();
    this.mq.addEventListener("change", this.onMq);
    this.applySpacing();

    this.querySelector("[data-mbb-menu]")?.addEventListener("click", () => {
      const toggler = document.querySelector('[aria-controls="header-mobile-menu"]');
      if (toggler) {
        toggler.click();
      } else {
        window.location.href = "/";
      }
    });

    if (this.dataset.hideOnScroll === "true") {
      this.lastY = window.scrollY;
      this.onScroll = () => this.handleScroll();
      window.addEventListener("scroll", this.onScroll, { passive: true });
    }
  }

  disconnectedCallback() {
    this.mq?.removeEventListener("change", this.onMq);
    if (this.onScroll) window.removeEventListener("scroll", this.onScroll);
    document.body.style.removeProperty("padding-bottom");
  }

  applySpacing() {
    if (this.mq.matches) {
      const h = this.offsetHeight || parseInt(this.dataset.height, 10) || 60;
      document.body.style.paddingBottom = `${h}px`;
    } else {
      document.body.style.removeProperty("padding-bottom");
      this.dataset.hidden = "false";
    }
  }

  handleScroll() {
    if (!this.mq.matches) return;

    const y = window.scrollY;
    const delta = y - this.lastY;

    if (Math.abs(delta) < 8) return;

    this.dataset.hidden = delta > 0 && y > 120 ? "true" : "false";
    this.lastY = y;
  }
}

if (!customElements.get("mobile-bottom-bar")) {
  customElements.define("mobile-bottom-bar", MobileBottomBar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banners"] && !Shopify.designMode) return;
  try {
    
class PromoBanners extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(".carousel-track");
    this.dotsWrapper = this.querySelector(".pb-dots");

    if (!this.track || !this.dotsWrapper) return;

    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    this.onScroll = this.throttle(() => this.setActiveDot(), 100);
    this.onResize = this.debounce(() => this.build(), 200);

    requestAnimationFrame(() => this.build());

    this.track.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize);
  }

  disconnectedCallback() {
    this.track?.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  get slides() {
    return Array.from(this.track.querySelectorAll(".carousel-slide"));
  }

  get slideStep() {
    const slides = this.slides;
    if (slides.length < 2) return slides[0]?.getBoundingClientRect().width || 1;
    return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left || 1;
  }

  get perView() {
    return Math.max(1, Math.round(this.track.clientWidth / this.slideStep));
  }

  build() {
    const total = this.slides.length;
    const perView = this.perView;
    const pages = Math.max(1, Math.ceil(total / perView));

    this.dotsWrapper.innerHTML = "";

    if (pages <= 1) return;

    for (let i = 0; i < pages; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", `Go to banner ${i * perView + 1} of ${total}`);
      dot.setAttribute("aria-current", i === 0 ? "true" : "false");
      dot.addEventListener("click", () => this.goToPage(i));
      this.dotsWrapper.appendChild(dot);
    }

    this.setActiveDot();
  }

  goToPage(index) {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const left = Math.min(index * this.perView * this.slideStep, maxScroll);

    this.track.scrollTo({
      left,
      behavior: this.reducedMotion ? "auto" : "smooth",
    });
  }

  setActiveDot() {
    const dots = Array.from(this.dotsWrapper.children);
    if (!dots.length) return;

    const pageWidth = this.perView * this.slideStep;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;

    let active =
      maxScroll > 0 && this.track.scrollLeft >= maxScroll - 4
        ? dots.length - 1
        : Math.round(this.track.scrollLeft / pageWidth);

    active = Math.max(0, Math.min(active, dots.length - 1));

    dots.forEach((dot, i) => {
      dot.setAttribute("aria-current", i === active ? "true" : "false");
    });
  }

  throttle(func, limit) {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= limit) {
        lastCall = now;
        func.apply(this, args);
      }
    };
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }
}

if (!customElements.get("promo-banners")) {
  customElements.define("promo-banners", PromoBanners);
}

  } catch(e) { console.error(e); }
})();
})();
